import { render, staticRenderFns } from "./Services_internet.vue?vue&type=template&id=60eea5a4&"
import script from "./Services_internet.vue?vue&type=script&lang=js&"
export * from "./Services_internet.vue?vue&type=script&lang=js&"
import style0 from "./Services_internet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Services_internet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports